module.exports = __webpack_public_path__ + "static/img/7.0d1772a.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting811/images/7.png
// module id = tGsG
// module chunks = 4